module.exports = __webpack_public_path__ + "static/media/12UNCTAD7.b3654894.jpg";